import * as React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CustomModal from '../../../../../components/custom-modal/CustomModal';
import { LoadingButton } from '@mui/lab';
import { markedAsCryopreserveLSM } from "../../../../../bmr/slices/manufacturer";
import { useDispatch } from 'react-redux';


const CryopeserveLsmModal = ({id, formProps, open, setOpen,getTimeLine }) => {
    const dispatch = useDispatch()

        const handleCryopreserved = async () => {
        try {
            // Prepare API payload with the selected restart option
            const payload = {
                subject_id: formProps?.subject_id,
                inbound_patient_id: formProps?.inbound_patient_id,
            }

            const res = await dispatch(markedAsCryopreserveLSM(payload)).unwrap();
            if (res?.status === 200) {
                setOpen(false)
                getTimeLine(id)
            }
        } catch (err) {
            console.error("Error LSM Approval:", err);
        }
    }

    return (
      <CustomModal open={open} setOpen={setOpen}>
        <div className="h-full flex flex-col gap-8 pl-3 pr-3 pt-4">
          {/* <div className="self-center">
            <DeleteModalIcon />
            </div> */}
          <Typography
            align="center"
            id="spring-modal-title"
            variant="h5"
            fontWeight={500}
            component="h5"
          >
            Would you like to move forward with cryopreservation and begin the manufacturing process with them?
          </Typography>
         <div className="flex justify-center gap-4">
           
            <LoadingButton
              variant="contained"
              className="w-[160px] h-[40px]"
              onClick={handleCryopreserved}
            >
              <span>Cryopreserved LSM</span>
            </LoadingButton>

            <Button
              variant="contained"
              className="w-[200px] h-[40px]"
              sx={{backgroundColor:"white",color:'currentColor','&:hover':{backgroundColor:"black",color:"white"},border:"1px solid Gray",}}
              onClick={() => {
                 setOpen(false)
              }}
            >
               Manufacturing
            </Button>
          </div>
        </div>
      </CustomModal>
    );
}
export default CryopeserveLsmModal;